// What a reviewer marked for the vendor's attention, by the editor tab it is fixed in: a product not on sale
// sent back (`lastReview.attention`: name, description, pictures…, or one thing in them — `pictures:cover`,
// `details:weight`), or changes to one on sale sent back (`reviewChange.attention`: name, description, images,
// price, type). Each tab that has something waiting carries a chip with how many (`reviewBadge(tab)`, its
// extension's `section.badge`); the Product Review tab and the header's shortcut carry them all.
import React from "react"
import { useCatalogEditor } from "./catalog-editor"
import { EPublishStatus } from "./editor-config"

// the tab (its extension's id) a mark is fixed in, by the part it names
const TAB_OF = {
  name: "product-info",
  description: "product-info",
  details: "product-info",
  pictures: "images",
  images: "images",
  price: "vendor-pricing",
  stock: "inventory",
  videos: "trailer",
  type: "product-type",
  category: "categories",
  delivery: "shipping",
  other: "admin-review",
}

// what a change to a product on sale is about, as the reviewer and the vendor read it (`t`: the host's texts;
// untranslated where there is none)
const CHANGE_LABELS = { name: "Name", description: "Description", type: "Type", price: "Price", images: "Images", videos: "Video" }
export const changeLabel = (kind, t = (s) => s) => (CHANGE_LABELS[kind] ? t(CHANGE_LABELS[kind]) : kind)

/** The marks waiting for the vendor: [{ id, label, note, tab }] (none once resolved or sent again). */
export function marksOf(editor) {
  const status = Number(editor?.read?.("publishStatus"))
  const sentBack = status === EPublishStatus.ReviewRequired ? (editor.read("lastReview")?.attention || []).filter((item) => !item.resolved) : []
  const change = editor?.read?.("reviewChange")
  const changes = change?.status === "changes_requested" ? (change.attention || []).filter((item) => !item.resolved).map((item) => ({ id: item.kind, label: changeLabel(item.kind), note: item.note })) : []
  return [...sentBack, ...changes].map((item) => ({ ...item, tab: TAB_OF[String(item.id).split(":")[0]] || "admin-review" }))
}

/** The chip: how many marks wait (a tab's, or all of them). */
export function ReviewCountChip({ count, title }) {
  if (!count) return null
  return (
    <span className="shrink-0 inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded-full bg-orange-500 text-white text-[11px] font-bold leading-none" title={title} data-testid="review-mark-count">
      {count}
    </span>
  )
}

/** A tab's badge: the marks fixed in it; the Product Review tab's, every mark. */
export const reviewBadge = (tab) =>
  function ReviewBadge() {
    const catalog = useCatalogEditor()
    if (!catalog?.ready) return null
    const marks = marksOf(catalog.editor)
    const count = tab === "admin-review" ? marks.length : marks.filter((mark) => mark.tab === tab).length
    return <ReviewCountChip count={count} title={marks.filter((mark) => tab === "admin-review" || mark.tab === tab).map((mark) => mark.label).join(", ")} />
  }
